import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页头条", href: "#home" },
  { label: "实时热搜", href: "#trending" },
  { label: "绯闻频道", href: "#gossip" },
  { label: "深度复盘", href: "#feature" },
  { label: "绯闻全记录", href: "#timeline" },
  { label: "关于瓜田", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="bg-primary-700 text-background-50 text-xs">
        <div className="mx-auto max-w-7xl px-4 md:px-6 flex items-center gap-4 h-8 overflow-hidden">
          <span className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-flashlight-fill text-accent-300" />
            <span className="tracking-wide font-medium">今日瓜讯</span>
          </span>
          <span className="whitespace-nowrap overflow-hidden text-ellipsis text-background-100">
            沈星野林眠同回公寓热度攀升 · 影后苏蔓官宣分手冲上榜首
          </span>
        </div>
      </div>

      <div
        className={`transition-all duration-300 border-b ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-background-200 shadow-sm"
            : "bg-background-50 border-background-100"
        }`}
      >
        <div className="mx-auto max-w-7xl px-4 md:px-6 flex items-center justify-between gap-4 h-16">
          <a href="#home" className="flex items-center gap-2.5 shrink-0" aria-label="绯闻瓜田首页">
            <span className="w-9 h-9 rounded-md bg-primary-600 text-background-50 flex items-center justify-center text-lg">
              <i className="ri-empathize-line"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-extrabold text-foreground-950">绯闻瓜田</span>
              <span className="text-[10px] tracking-[0.2em] text-foreground-500">MELON DAILY</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-7" aria-label="主导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form
              className="hidden md:flex items-center bg-background-100 border border-background-200 rounded-md pl-3 h-9 focus-within:border-primary-300"
              onSubmit={(e) => e.preventDefault()}
              role="search"
            >
              <i className="ri-search-line text-foreground-400 text-sm"></i>
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜搜明星与瓜料"
                className="bg-transparent outline-none text-sm px-2 w-36 placeholder:text-foreground-400"
                aria-label="站内搜索"
              />
              <button
                type="submit"
                className="h-8 w-8 mr-1 rounded-md flex items-center justify-center bg-primary-600 text-background-50 hover:bg-primary-700 transition-colors text-sm"
                aria-label="提交搜索"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>

            <a
              href="#subscribe"
              className="hidden sm:inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium px-4 h-9 hover:bg-primary-700 transition-colors"
            >
              订阅早报
            </a>

            <button
              className="lg:hidden w-9 h-9 rounded-md border border-background-200 flex items-center justify-center text-foreground-800 text-lg"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <nav
            className="lg:hidden bg-background-50 border-t border-background-100 px-4 py-3 flex flex-col gap-1"
            aria-label="移动端导航"
          >
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="py-2 text-sm text-foreground-800 hover:text-primary-600 border-b border-background-100 last:border-0"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-2 rounded-md bg-primary-600 text-background-50 text-sm font-medium px-4 py-2.5 text-center"
            >
              订阅吃瓜早报
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}